export default "__VITE_ASSET__D4VMv5yO__"